import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from 'vuetify/lib/locale/en'
import fi from 'vuetify/lib/locale/fi'

Vue.use(VueI18n)

const messages = {
  en: {
    ...require('@/locales/en.json'),
    $vuetify: en,
  },
  fi: {
    ...require('@/locales/fi.json'),
    $vuetify: fi,
  },
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'fi',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fi',
  messages,
})
